import React from 'react'

export default ({ children }) => (
  <section className="toolbar">
    <div className="toolbar__container">{children}</div>
  </section>
)
